// Класс строки для выплаты партнёру и её знак внутри класса.
// counts_categories.operation_type — перечисление, а не булево: 0 расход, 1 доход, 2 залоги,
// 3 внутренние переводы. Залоги и переводы в выплату не входят — null.
// Знак — по направлению операции, по тому же правилу, что в каталоге
// (Analytics::FleetEconomics.money_by_car): доход — приход минус возвраты клиенту, расход — расход
// минус его возвраты.
//
// Доходные категории, которые не доход партнёра (решение USER 2026-10-08, как выплата в API —
// Analytics::InvestorPayout): пополнение баланса клиента — обязательство (деньги клиента лежат у нас,
// доход возникнет, когда он оплатит ими аренду, и попал бы в выплату дважды), продажа имущества — не
// аренда. «Аренда с выкупом» по машине партнёра — его доход (партнёр не отдаёт машину под выкуп).
// Совпадение по названию системной категории, как у Analytics::CashClassifier.
export const NOT_PARTNER_INCOME_CATEGORIES = ["Пополнение баланса клиента", "Продажа имущества"];

export function investorCountClass(counts_category, count) {
  if (NOT_PARTNER_INCOME_CATEGORIES.includes(counts_category.value)) return null;
  if (counts_category.operation_type === 1) {
    return { income: true, sign: count.operation ? 1 : -1 };
  } else if (counts_category.operation_type === 0) {
    return { income: false, sign: count.operation ? -1 : 1 };
  }
  return null;
}

// Категория «Аренда с выкупом» — системная: её ставит API всем доходным платежам на бронировании договора выкупа, договор
// партнёра её не перечисляет. Доход партнёра — всегда, без привязки (решение USER 2026-10-08, как выплата в API —
// Analytics::InvestorPayout::BOUND_CATEGORY_SQL).
export const RENT_TO_OWN_CATEGORY = "Аренда с выкупом";

// id категорий группы, платежи которых относятся к партнёру: совпадение по названию с категориями договора (категории
// заводятся на филиал, одно название — несколько id) плюс «Аренда с выкупом».
export function partnerCategoryIds(investorCategories, allCategories) {
  const names = (investorCategories || []).map((category) => category.value);
  return (allCategories || [])
    .filter((category) => names.includes(category.value) || category.value === RENT_TO_OWN_CATEGORY)
    .map((category) => category.id);
}
